import Datas from "./Datas";
import List from "./List";

const TypeSolicitationReason = {
    Datas,
    List
}

export default TypeSolicitationReason;